import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as types from '../../../../constants/actionTypes';
import { actions as baselineTaskActions } from '../../../../actions/baselineTaskActions';
import PropTypes from 'prop-types'
import Drawer from '../../../Common/Drawer/Drawer';
import Notification from '../../../Common/Notification';
import LoadingIndicator from '../../../Common/LoadingIndicator/LoadingIndicator';
import './BulkUpdateAttributesDrawer.scss';
import CrossBaselineTaskForm from './CrossBaselineTaskForm';
import { DATE_FORMAT } from '../../../../constants/constants';
import Moment from 'moment';
import _ from 'lodash';

export class BulkUpdateAttributesDrawer extends Component {
    constructor(props, context) {
        super(props, context);

        const newTask = {
            id: 0,
            name: "",
            additionalInfo: "",
            phaseId: "",
            departmentId: "",
            communityId: "",
            jobTitleId: "",
            taskTagIds: [],
            isTrickleDown: true
        };

        this.state = {
            editTask: newTask,
            unchangedTask: newTask,
            newTask: newTask,
            isFormValid: true,
            showDateError: false,
            isLoading: false,
            taskSearchResults: [],
            taskPrereqSearchResults: [],
            unsavedChanges: false,
            saveAndNewRetention: false
        };
    }

    async componentDidMount() {
        await this.loadTask(this.props.taskId);
    }
    

    componentDidUpdate(prevProps) {
        if(this.props.taskId !== prevProps.taskId){
            this.loadTask(this.props.taskId);
        }
    }

    loadTask = async (taskId) => {

        if (taskId == null) {
            return;
        }
        try {
            this.setState({ isLoading: true });
            const response = await this.props.baselineTaskActions.loadBaselineTask(taskId);
            if (response.type === types.LOAD_BASELINE_TASK_SUCCESS) {

                let task = response.payload;

                // we either show static dates (datepickers) or target dates (inputs)
                // if either one of the static dates exists then default to showing those instead
                if (task.targetStaticDate || task.startStaticDate) {
                    task.showStaticDates = true;
                }

                // format dates for datepicker
                if (task.targetStaticDate) {
                    const targetDate = new Date(task.targetStaticDate);
                    task.targetStaticDate = Moment.utc(targetDate).format(DATE_FORMAT);
                }

                if (task.startStaticDate) {
                    const startDate = new Date(task.startStaticDate);
                    task.startStaticDate = Moment.utc(startDate).format(DATE_FORMAT);
                }

                // format numerical values for target inputs (values can be negative!)
                // the value in the db is the total days, but the ui splits that total up between days and weeks
                task.targetWeeks = parseInt(task.targetDaysOut / 7);
                task.targetDays = (task.targetWeeks != 0) ? task.targetDaysOut % 7 : task.targetDaysOut;

                task.startWeeks = parseInt(task.startDaysOut / 7);
                task.startDays = (task.startWeeks != 0) ? task.startDaysOut % 7 : task.startDaysOut;

                // Format audit dates just to match the rest of the date formatting
                const dateCreated = new Date(task.createdDate);
                task.dateCreated = Moment.utc(dateCreated).format(DATE_FORMAT);
                const dateModified = task.modifiedDate ? new Date(task.modifiedDate) : "";
                task.dateModified = dateModified ? Moment.utc(dateModified).format(DATE_FORMAT) : "";

                const newTask = { ...this.state.newTask, ...task };
                if (!newTask.links || !newTask.links.length) {
                    newTask.links == this.state.newTask.links; // Ensure always a blank link ready for editing
                }
                this.setState({ editTask: newTask, unchangedTask: newTask, isDrawerOpen: true, isFormValid: true });

            } else if (response.type === types.LOAD_BASELINE_TASK_FAILURE) {
                Notification("error", "An Error Occurred", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    searchTasks = async (searchTerm) => {
        try {
            const response = await this.props.baselineTaskActions.optionSearch(searchTerm, this.state.editTask.baselineId, this.state.editTask.id, false);
            if (response.type === types.OPTION_SEARCH_BASELINE_TASK_SUCCESS) {
                this.setState({ taskSearchResults: response.payload.results });
            } else if (response.type === types.OPTION_SEARCH_BASELINE_TASK_FAILURE) {
                Notification("error", "An Error Occurred", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        }
    }

    onFormChange = (name, value) => {
        let newTask = {
            ...this.state.editTask,
            [name]: value
        };

        if(name === "isActive" && value === false){
            // #1249 ensure the default is false
            newTask = {
                ...newTask,
                isLocationTaskListActive: false
            }
        } else if(name === "showStaticDates"){
            // statics dates cannot be locked, days out has a choice but set the default here when they switch
            newTask = {
                ...newTask,
                isLocationTaskDateAdjustable: (value === true) ? false : true
            }
        }

        this.setState({ editTask: newTask }, () => {
            this.checkForChanges();
        });
    }

    checkForChanges = () => {
        // compare unChangedTask to editTask if editing a task
        if (this.state.editTask.id != 0) {
            const haveTheSameValues = _.isEqual(this.state.unchangedTask, this.state.editTask);
            this.setState({ unsavedChanges: !haveTheSameValues });
        }
    }

    onSave = async () => {
        
        const checkedTasksIds = this.props.checkedTasks.map(obj => obj.id);
        let task = { ...this.state.editTask , baselineTaskIds: [...checkedTasksIds]  };

        this.setState({ isFormValid: true, isLoading: true });

        //transforms taskTagIds from string to array of strings
        if (task.taskTagIds && task.taskTagIds.length > 0 && !Array.isArray(task.taskTagIds)) {
            task.taskTagIds = task.taskTagIds.split(",");
        }
        
        try {
            const response = await this.props.baselineTaskActions.updateCrossBaselineTasks(task);
            if (response.type === types.UPDATE_BASELINE_TASK_SUCCESS) {
                Notification("success", "Success", "Baseline Tasks Updated");
                this.props.onComplete();
            } else if (response.type === types.UPDATE_BASELINE_TASK_FAILURE) {
                Notification("error", "An Error Occurred", response.payload.message);
                this.setState({ isLoading: false });
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
            this.setState({ isLoading: false });
        }
    
    }

    renderFooter = () => {
        if(this.props.isMobile){
            return <div>
                    <div className="button-wrap">{this.state.editTask.id > 0 && this.state.unsavedChanges ? <span>You have unsaved changes</span> : ""}</div>
                    <div className="button-wrap">                <button type="button" className="btn btn-primary button--save" onClick={this.onSave}>{this.state.editTask.id === 0 ? 'Save' : 'Apply Changes'}</button>
                <button type="button" className="btn btn-secondary" onClick={this.props.onCancel}>Cancel</button></div>
                </div>
        }
        else
        {
            return <div className="button-wrap">
                {this.state.editTask.id > 0 && this.state.unsavedChanges ? <span>You have unsaved changes</span> : ""}
                <button type="button" className="btn btn-primary button--save" onClick={this.onSave}>Update</button>
                <button type="button" className="btn btn-secondary" onClick={this.props.onCancel}>Cancel</button>
            </div>
        }
    }

    render() {

        const customFooter = this.renderFooter();

        return (
            <div>
                <Drawer isWide={true} title='Update Attributes'
                    onSaveClick={this.onSave}
                    saveText='Save'
                    onCancelClick={this.props.onCancel}
                    customFooter={customFooter}>
                    <LoadingIndicator isLoading={this.state.isLoading}>
                         <CrossBaselineTaskForm
                            task={this.state.editTask}
                            filters={this.state.filters}
                            isFormValid={this.state.isFormValid}
                            showDateError={this.state.showDateError}
                            linksShown={this.state.editTask.linksShown}
                            onFormChange={this.onFormChange}
                            formFilters={this.props.formFilters}
                            taskSearch={this.searchTasks}
                            taskSearchResults={this.state.taskSearchResults}
                            baselineTaskActions={this.props.baselineTaskActions}
                            checkedTasks={this.props.checkedTasks}
                        />
                    </LoadingIndicator>
                </Drawer>
            </div>
        )
    }
}

BulkUpdateAttributesDrawer.propTypes = {
    onCancel: PropTypes.func.isRequired,
    checkedTasks: PropTypes.array.isRequired,
    baselineTaskActions: PropTypes.object.isRequired,
    taskId: PropTypes.any,
    onComplete: PropTypes.func.isRequired,
    isMobile: PropTypes.func.isRequired,
    formFilters: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
    return {
        baselineTaskActions: bindActionCreators(baselineTaskActions, dispatch)
    };
}

export default connect(null, mapDispatchToProps)(BulkUpdateAttributesDrawer);